//import React from "react";
import React, { useEffect, useState, } from "react";
import { useHistory } from "react-router-dom";
import Admin from "layouts/Admin";
import Footer from "components/Footer/Footer";
// import Background from 'assets/img/a.jpg';

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
} from "react-bootstrap";
import { createPrinter } from "typescript";

import firebase from "../firebase";

const assigndrivers=()=> {

  let history = useHistory();
  
//Stroring Reteriwing Data
const[userData,setUserData]= useState([]);

useEffect(()=>{

  const files = firebase.database().ref("StaffDriver");
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    setUserData(dataList);
    console.log(dataList);
  }) 
    
},[]);


// const updateButtoclk = (data) => {
//   let indi = true;

//   history.push({pathname:'/admin/UpdateAccDetails', state:data});
// }
    

const filterData=(datas,searchKey)=>{

  const result = datas.filter(
    (data)=>
    data.NIC.toLowerCase().includes(searchKey) ||
    data.Age.toLowerCase().includes(searchKey)
     //Searching via 
  );
  setUserData(result);
}

const Changestatus = (id,status) =>{
  const files = firebase.database().ref("StaffDriver").child(id);
  
  let data = {
    Status:status, 
  };
  files.update(data);
  if(status == 1){
    alert("Activated");
  }
  else if(status == 0){
    alert("Deactivated");
  }
  
}


const handleInput=(e)=>{
  const searchKey = e.currentTarget.value;

  const files = firebase.database().ref("StaffDriver");
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    //
    filterData(dataList, searchKey);
  }) 
    

}

// var sectionStyle = {
//   width: "100%",
//   height: "100%",
//   backgroundImage: `url(${Background})`
// };




  return (
    <>
    {/* <section style={ sectionStyle }> */}

<Admin/>

<br/>

<Container>
  <Row>
    <Col md={{ span: 12, offset: 1 }}>  




    <Container fluid>
{/* <FormControl
    type="search"
    placeholder="Search by NIC" 
    className="mr-2"
    aria-label="Search"
    name="searchQuery"
    onChange={handleInput}
  /> */}
 <br/>
        <Table className = "text-center" striped bordered hover>
        <thead>
            <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Phone Number</th>
            <th>Address</th>
            <th>Driving Licence image</th>
            <th>Vehicle Licence Image</th>
            <th><center></center></th>
            <th><center></center></th>
            
            
            </tr>
        </thead>
        <tbody>{userData.map((data, index)=>(
            <tr>
            <td>{data.FName}</td>
            <td>{data.LName}</td>
            <td>{data.Phone}</td>
            <td>{data.Address}</td>
            <td>{data.Img01}</td>
            <td>{data.Img02}</td>
            
    
            <center>
            <Button onClick={()=>Changestatus(data.id,1)}  className = "mx-2" variant="primary" size="" active>
              Activate
            </Button>{' '}
            </center>
            <center>
            <Button onClick={()=>Changestatus(data.id,0)} className = "ml-2 mr-0" variant="primary" size="" active>
              Deactivate 
            </Button>

            </center>

            </tr>
            ))}
        </tbody>
        </Table>
        </Container>
        

        
      </Col>
  </Row>
</Container>

<Footer /> 

{/* </section> */}

</>

        ) ;
    }
export default assigndrivers;